module.exports = __webpack_public_path__ + "static/media/avive_aed_accepted_active.5e78ddc8.svg";